import { __assign } from "tslib";
// DS: i4.9
import React from 'react';
import IconWrap from '../../IconWrap';
var Newest = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M21.24 3a.76.76 0 01.752.866l-.02.1-2.062 7.28a1 1 0 01-.19.364l-.094.1-1.113 1.025a1 1 0 01-.553.257l-.125.008h-1.933l1.87-5.34a.497.497 0 00-.47-.66c-.438 0-.85.214-1.101.573L13 12.146V20a1 1 0 01-2 0V8l.002.001V6.46a1 1 0 01.308-.721l.088-.076 3.244-2.46a1 1 0 01.475-.195l.13-.008h5.993zM7.51 9a1 1 0 01.754.343l1.49 1.708a1 1 0 01.246.657V16H5.65a1 1 0 01-.666-.254l-.825-.736a1 1 0 01-.282-.428L2.26 9.775A.587.587 0 012.817 9H7.51z", fillRule: "evenodd" }))));
};
Newest.displayName = 'Newest';
export default Newest;
//# sourceMappingURL=Newest.js.map